/*
 * @Author: your name
 * @Date: 2022-03-16 11:07:26
 * @LastEditTime: 2022-03-16 17:02:28
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /es-package/packages/es-mpx-bridge/lib/omega/index.web.js
 */

import { composeOmega } from './common'

if (!window.Omega) {
  console.log('没有配置Omega的SDK，数据将无法上报')
}
export default {
  getOmega: () => composeOmega(window.Omega)
}